module.exports = __webpack_public_path__ + "media/images/how-img-1440-718460dd4f5804430d5f417d21ea404f.svg";